import React from 'react';

const Logo = (props) => {
  return <img src="/images/logo.png" width={140} alt="Logo" {...props} />;
};

export default Logo;
